if (!customElements.get('pw-card-gallery')) {
  customElements.define('pw-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.pw-card-gallery__track');
      const bar = this.querySelector('.pw-card-gallery__bar');
      let startX = 0, startY = 0, moved = false, mouseDragging = false, startScroll = 0;
      track.addEventListener('pointerdown', event => {
        startX = event.clientX; startY = event.clientY; moved = false;
        mouseDragging = event.pointerType === 'mouse' && event.button === 0;
        startScroll = track.scrollLeft;
      }, options);
      track.addEventListener('pointermove', event => {
        if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) moved = true;
        if (mouseDragging && moved) {
          track.setPointerCapture(event.pointerId);
          track.style.scrollSnapType = 'none';
          track.scrollLeft = startScroll + startX - event.clientX;
          event.preventDefault();
        }
      }, options);
      const finishDrag = () => {
        if (!mouseDragging) return;
        mouseDragging = false;
        track.style.scrollSnapType = '';
        const index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
      };
      track.addEventListener('pointerup', finishDrag, options);
      track.addEventListener('pointercancel', finishDrag, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      track.addEventListener('click', event => {
        if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; }
      }, options);
      track.addEventListener('scroll', () => {
        const index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        bar.style.setProperty('--pw-index', index);
      }, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        track.scrollBy({ left: track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior: 'auto' });
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}


if (!window.pwCollectionImageRecovery) {
  window.pwCollectionImageRecovery = true;
  const recover = image => {
    if (!(image instanceof HTMLImageElement) || !image.closest('.card-wrapper')) return;
    const original = image.currentSrc || image.src;
    if (!original) return;
    const attempts = Number(image.dataset.pwRecoveryAttempts || 0);
    if (attempts >= 2) return;
    const fallback = image.closest('.card-wrapper').querySelector('.card__inner img');
    const url = new URL(attempts === 1 && fallback && fallback !== image ? fallback.currentSrc || fallback.src : original, location.origin);
    if (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com') return;
    if (url.pathname.startsWith('/cdn/shop/')) {
      url.hostname = 'cdn.shopify.com';
      url.pathname = url.pathname.replace('/cdn/shop/', '/s/files/1/1320/6427/');
    }
    url.searchParams.set('format', 'pjpg');
    url.searchParams.set('width', '720');
    if (attempts === 1) url.searchParams.set('pw_retry', '2');
    image.dataset.pwRecoveryAttempts = String(attempts + 1);
    image.removeAttribute('srcset');
    image.src = url.href;
  };
  document.addEventListener('error', event => recover(event.target), true);
  document.querySelectorAll('.card-wrapper img').forEach(image => {
    if (image.complete && image.naturalWidth === 0) recover(image);
  });
}
